import { StatusCompleteFilledSmall } from '@wix/wix-ui-icons-common';
import React, { FC } from 'react';
import { Box, Image, Text, Card as WSRCard } from '@wix/design-system';
import { Addon } from '../../../types/addons';
import { useTranslation } from '../../useTranslation';
import styles from './addonsCard.module.scss';
import { SvgFallbackLogo } from '../../shared/panel/svg/svgFallbackLogo';
import { useBi } from './useBi';

interface Props {
  addon: Addon;
  isInstalled: boolean;
}

export const Card: FC<Props> = ({ addon, isInstalled }) => {
  const [t] = useTranslation();
  const bi = useBi();

  const { name, author, iconUrl, description } = addon;

  const logo = iconUrl ? (
    <Image
      alt={`${name} addon icon`}
      src={iconUrl}
      borderRadius={6}
      width={36}
      height={36}
      showBorder
      transparent
    />
  ) : (
    <SvgFallbackLogo />
  );

  const handleMouseEnter = () => {
    bi.addonHover({
      action_context: addon.appDefinitionId,
      origin: 'addon_market_card',
    });
  };

  return (
    <div onMouseEnter={handleMouseEnter}>
      <WSRCard className={styles.wrapper}>
        <Box
          padding="SP3"
          direction="vertical"
          height="198px"
          className={styles.root}
        >
          <Box marginBottom="SP2">{logo}</Box>

          <Box direction="vertical" marginBottom="SP1">
            <Box marginBottom="2px">
              <Text weight="bold" size="small" ellipsis maxLines={2}>
                {name}
              </Text>
            </Box>

            <Box>
              <Text size="tiny">
                {t('PLATFORM_addons_panel_addon_card_dev_label', {
                  company_name: author,
                })}
              </Text>
            </Box>
          </Box>

          <Box paddingBottom="SP1">
            <Text size="tiny" ellipsis maxLines={2}>
              {description}
            </Text>
          </Box>

          <Box flexGrow={1} />

          {isInstalled && (
            <Box>
              <Text
                size="tiny"
                skin="success"
                className={styles.labelInstalled}
                dataHook="addonsMarket.isInstalled"
              >
                <StatusCompleteFilledSmall />
                {t('PLATFORM_addons_panel_addon_card_installed_label')}
              </Text>
            </Box>
          )}
        </Box>
      </WSRCard>
    </div>
  );
};
